<div class="containerInserimentoLicord">
    <form id="contact" style="margin-bottom:8px; width:100%">
        <h3 style="text-align:center">Licord</h3>   
        <h4 style="text-align:center">Dati del dispositivo</h4>
        <div class="containerFormLicord">
            <div>
                <p>
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>ID dispositivo</mat-label>
                        <input [(ngModel)]="serialNumber" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Numero progressivo</mat-label>
                        <input [(ngModel)]="progressiveNumber" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Seriale cella</mat-label>
                        <input [(ngModel)]="serialCella" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Fondo scala</mat-label>
                        <input type="number" [(ngModel)]="fondoScala" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Sensibilità cella</mat-label>
                        <input type="number" [(ngModel)]="sensibilityCella" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Fattore calibrazione</mat-label>
                        <input type="number" [(ngModel)]="fattore_calibrazione" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Note</mat-label>
                        <input type="text" [(ngModel)]="ds_note" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
            </div>
            <div>
                <p class="pdxInserimentoLicord">
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Delta_T</mat-label>
                        <input type="number" [(ngModel)]="delta_t" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p >
                    <mat-form-field appearance="outline" class="byclass wakez">
                        <mat-label>Wake up 1</mat-label>
                        <input type="time" [(ngModel)]="wake_up_1" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p >
                    <mat-form-field appearance="outline" class="byclass wakez">
                        <mat-label>Wake up 2</mat-label>
                        <input type="time" [(ngModel)]="wake_up_2" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p >
                    <mat-form-field appearance="outline" class="byclass wakez">
                        <mat-label>Wake up 3</mat-label>
                        <input type="time" [(ngModel)]="wake_up_3" matInput [ngModelOptions]="{standalone: true}" readonly>
                    </mat-form-field>
                </p>
                <p class="pdxInserimentoLicord">
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Data installazione</mat-label>
                        <input matInput [(ngModel)]="ds_data_installazione" [matDatepicker]="picker" [ngModelOptions]="{standalone: true}" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </p>
                <p class="pdxInserimentoLicord">
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>{{modemssid}}</mat-label>
                        <mat-select [(ngModel)]="ds_modem_key" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let item of modemList" value="{{item.key}}" readonly>{{item.ssid}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </p>
            </div>
        </div>
        <fieldset
            style="
                margin-top: 20px;
                margin-bottom: -40px
            "
        >
            <button 
                data-submit="...Sending" 
                class="btn-annulla"
                (click)="close()"
                id="contact-submit"
                type="submit" 
                name="submit" 
            >
                <mat-icon 
                    style="
                        margin-right: 25px; 
                        transform: scale(2.3);
                        position: relative;
                        top: 2px
                    "
                >clear</mat-icon>
                <span 
                    style="
                        position: relative; 
                        top: -3px
                    "
                >CHIUDI</span>
            </button>
        </fieldset>
    </form>
</div>
